<h1>Daily duration calculator</h1>

<div class="result-wrapper">
  <div class="side-panel-container">
    <div class="form-container">
      <h2>Data:</h2>
      <div class="input-container">
        <p class="input-label">Starting level</p>
        <input
          class="data-input"
          type="number"
          [min]="86"
          [max]="190"
          [(ngModel)]="startingLevel"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Starting xp</p>
        <input
          class="data-input"
          type="number"
          step="0.0001"
          [min]="0"
          [max]="100"
          [(ngModel)]="startingXp"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Target level</p>
        <input
          class="data-input"
          type="number"
          [min]="87"
          [max]="190"
          [(ngModel)]="targetLevel"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Target XP</p>
        <input
          class="data-input"
          type="number"
          step="0.0001"
          [min]="0"
          [max]="100"
          [(ngModel)]="targetXp"
        />
      </div>
      <div class="input-container">
        <p class="input-label">Do tower until</p>
        <input
          class="data-input"
          type="number"
          [min]="162"
          [max]="190"
          [(ngModel)]="doTowerUntil"
        />
      </div>
      <div class="button-container">
        <button (click)="calculateDailyDuration(false)">Calculate days</button>
      </div>
      <div class="button-container">
        <button (click)="calculateDailyDuration(true)">Calculate XP per day</button>
      </div>
    </div>
    <div class="result-container">
      <h2>Results:</h2>
      <div class="input-container">
        <div class="input-label">
          <p>Total days needed: {{ totalDaysNeeded }}</p>
        </div>
      </div>
      <div class="input-container" *ngIf="noXpAvailable">
        <div class="input-label">
          <p>No quests give XP past level {{ lastReachedLevel }} with the current "Do tower until" setting, so the target level can't be reached. Try increasing "Do tower until".</p>
        </div>
      </div>
    </div>
  </div>
  <div class="upgrade-chart">
    <canvas id="upgrade-data-chart"></canvas>
  </div>
</div>
